// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchResults-module_list_2AV2c","result":"SearchResults-module_result_3-uXL","link":"SearchResults-module_link_3VC4l","viewAll":"SearchResults-module_viewAll_f6TpA"};